// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { EnquiryResponseNewCustomerFragmentDoc } from '../enquiryResponseNewCustomer.fragment.generated';
import { CustomerRegistrationResponseFragmentDoc } from '../../../../graphql/api/auth/fragments/customerRegistrationResponse.generated';
import { LoginResponseSuccessFragmentDoc } from '../../../../graphql/api/auth/fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../../../../graphql/api/fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../../../graphql/api/fragments/costumerConsultant.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateEnquiryNewCustomerDocument = `
    mutation createEnquiryNewCustomer($input: EnquiryInput!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  createEnquiryNewCustomer(input: $input, customer: $customer) {
    ...enquiryResponseNewCustomer
  }
}
    ${EnquiryResponseNewCustomerFragmentDoc}
${CustomerRegistrationResponseFragmentDoc}
${LoginResponseSuccessFragmentDoc}
${MeFragmentDoc}
${CostumerConsultantFragmentDoc}`;

export function useCreateEnquiryNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateEnquiryNewCustomerMutation, SchemaTypes.CreateEnquiryNewCustomerMutationVariables>(CreateEnquiryNewCustomerDocument);
};